import React from 'react';

const Context = React.createContext();

const ToggleContext = React.createContext();

const RequestContext = React.createContext();

export { Context, ToggleContext, RequestContext };
